<template>
    <div></div>
</template>

<script>
import { BCard, BCardBody, BCardHeader, BCardText, BCardTitle, BCol, BFormGroup, BFormInput, BRow } from 'bootstrap-vue';

export default {
    name: "addSale",
    component: {
        BCard,
        BCardHeader,
        BCardTitle,
        BCardText,
        BCardBody,
        BFormGroup,
        BFormInput,
        BCol,
        BRow
    }
}
</script>